/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__Question_0Inputs */

const en_help_center__shipping_n_delivery__question_0 = /** @type {(inputs: Help_Center__Shipping_N_Delivery__Question_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where do you ship?`)
};

/**
* | output |
* | --- |
* | "Where do you ship?" |
*
* @param {Help_Center__Shipping_N_Delivery__Question_0Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__question_0 = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__Question_0Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__Question_0Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__shipping_n_delivery__question_0(inputs)
});